export default __webpack_public_path__ + "static/media/gcp_logo.63bb0649.png";